import { REVERSE_PROXY_CONFIG } from '../config';

export const isReverseProxyDisabled = (): boolean => {
  const config = REVERSE_PROXY_CONFIG;
  if (!config) return false;
  if (config.disableForAll) return true;

  const tenantAlias = window.location.hostname.split('.')[0].toLowerCase();
  const disabledTenants = Array.isArray(config.disabledTenants) ? config.disabledTenants : [];
  return disabledTenants.some((tenant: string) => tenant.toLowerCase() === tenantAlias);
};
